import { css, styled } from '../../styles';
export const NODE_ITEM_HEIGHT = 41;

const $virtualizedStyle = css`
  position: absolute;
  height: 100%;
  width: 100%;

  .label {
    max-width: 100%;
  }
`;

const $hideIconsWhenNoMatch = css`
  .match:not(.child-match) {
    > .node-content .button-container {
      visibility: hidden;
    }
    > .children-wrapper {
      display: none;
    }
  }
`;

const $focusElementStyle = css`
  &[data-focus='true'],
  &:hover {
    background-color: rgba(0, 0, 0, 0.04);
  }
`;

export const StyledCheckboxTreeContainer = styled('div')<{
  $virtualized?: boolean;
}>`
  .label {
    display: -webkit-box;
    max-width: 200px;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    -webkit-hyphens: auto;
    -ms-hyphens: auto;
    hyphens: auto;
    word-break: break-word;
  }

  ${({ $virtualized }) => ($virtualized ? $virtualizedStyle : undefined)}
  ${$hideIconsWhenNoMatch}

  > .node.parent {
    padding: 0;
  }

  .node-content {
    display: grid;
    grid-template-columns: min-content 25px minmax(0, 1fr);
    align-items: center;
    justify-items: stretch;
    justify-content: stretch;

    &.hidden-button {
      grid-template-columns: min-content 1fr;
    }

    .button-container {
      text-align: center;
      padding-left: 4px;
    }
  }

  .node-value {
    height: ${NODE_ITEM_HEIGHT}px;
    display: flex;
    width: 100%;
    padding-left: 4px;

    & > .MuiFormGroup-root {
      margin: 0;
      
      .MuiCheckbox-root {
        padding-bottom: 7px;
      }
    }
  }
  .node {
    min-width: 1rem;
    min-height: 1rem;

    ${({ $virtualized }) => ($virtualized ? $focusElementStyle : undefined)}
  }
  .children-wrapper {
    padding-left: 1rem;
  }
  .collapsed {
    display: none;
  }
`;
